import { render, staticRenderFns } from "./ShipMarineTrafficStatusWidget.vue?vue&type=template&id=c1f80e36&scoped=true"
import script from "./ShipMarineTrafficStatusWidget.vue?vue&type=script&lang=js"
export * from "./ShipMarineTrafficStatusWidget.vue?vue&type=script&lang=js"
import style0 from "./ShipMarineTrafficStatusWidget.vue?vue&type=style&index=0&id=c1f80e36&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c1f80e36",
  null
  
)

export default component.exports